export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-end pb-32 overflow-hidden bg-gradient-radial from-[#1A1F3A] via-[#0A0E27] to-[#0A0E27]">
      {/* Animated particles background */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-purple-400 rounded-full animate-pulse"></div>
        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-blue-400 rounded-full animate-pulse delay-100"></div>
        <div className="absolute bottom-1/3 left-1/2 w-2 h-2 bg-purple-300 rounded-full animate-pulse delay-200"></div>
        <div className="absolute top-2/3 right-1/4 w-1 h-1 bg-blue-300 rounded-full animate-pulse delay-300"></div>
      </div>

      {/* Left content */}
      <div className="relative z-10 ml-[160px] max-w-4xl">
        <h1 className="text-white font-extralight text-7xl leading-tight tracking-wide">
          Modern iOS Applications
          <br />
          <span className="text-purple-300">For Enhanced Security</span>
          <br />
          And User Experience
        </h1>
      </div>

      {/* Right mockup */}
      <div className="absolute right-[10%] top-1/2 -translate-y-1/2 w-[35%]">
        <div className="relative transform rotate-[15deg]">
          <img
            src="https://public.readdy.ai/ai/img_res/3577f3777df9528ebe68d8a02aff11e1.jpg"
            alt="iOS App Mockup"
            className="w-full h-auto object-contain drop-shadow-2xl"
          />
        </div>
        
        {/* Floating label */}
        <div className="absolute top-[15%] right-[-10%] border-2 border-white/80 rounded-full px-6 py-2 backdrop-blur-sm">
          <span className="text-white text-sm font-light tracking-wider">iOS Experts</span>
        </div>
      </div>
    </section>
  );
}